import { createSlice } from "@reduxjs/toolkit";
import {
  getCustomerDetail,
  getAllMealOnOrder,
  addOrupdateCustomerOrder,
  verifyOrderStartDate,
  addOrupdateDeliverAnOrder,
  getCustomerDataDeliverAnOrder,
  collectPayment,
} from "../thunks/orderCustomerThunk";

const initialState = {
  isOrderLoading: false,
  isCustomerDataLoading: false,
  getMeals: [],
};

const orderCustomerSlice = createSlice({
  name: "customerOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerDetail.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(getCustomerDetail.fulfilled, (state, action) => {
        ((state.isOrderLoading = false), (state.action = action.payload));
      })
      .addCase(getCustomerDetail.rejected, (state) => {
        state.isOrderLoading = false;
      })
      .addCase(getAllMealOnOrder.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(getAllMealOnOrder.fulfilled, (state, action) => {
        ((state.isOrderLoading = false),
          (state.getMeals = action.payload.data || []));
      })
      .addCase(getAllMealOnOrder.rejected, (state) => {
        state.isOrderLoading = false;
      })
      .addCase(addOrupdateCustomerOrder.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(addOrupdateCustomerOrder.fulfilled, (state, action) => {
        ((state.isOrderLoading = false), (state.action = action.payload));
      })
      .addCase(addOrupdateCustomerOrder.rejected, (state) => {
        state.isOrderLoading = false;
      })
      .addCase(verifyOrderStartDate.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(verifyOrderStartDate.fulfilled, (state, action) => {
        ((state.isOrderLoading = false), (state.action = action.payload));
      })
      .addCase(verifyOrderStartDate.rejected, (state) => {
        state.isOrderLoading = false;
      })
      .addCase(addOrupdateDeliverAnOrder.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(addOrupdateDeliverAnOrder.fulfilled, (state, action) => {
        ((state.isOrderLoading = false), (state.action = action.payload));
      })
      .addCase(addOrupdateDeliverAnOrder.rejected, (state) => {
        state.isOrderLoading = false;
      })
      .addCase(getCustomerDataDeliverAnOrder.pending, (state) => {
        state.isCustomerDataLoading = true;
      })
      .addCase(getCustomerDataDeliverAnOrder.fulfilled, (state, action) => {
        ((state.isCustomerDataLoading = false),
          (state.action = action.payload));
      })
      .addCase(getCustomerDataDeliverAnOrder.rejected, (state) => {
        state.isCustomerDataLoading = false;
      })
      .addCase(collectPayment.pending, (state) => {
        state.isOrderLoading = true;
      })
      .addCase(collectPayment.fulfilled, (state, action) => {
        ((state.isOrderLoading = false), (state.action = action.payload));
      })
      .addCase(collectPayment.rejected, (state) => {
        state.isOrderLoading = false;
      });
  },
});

export default orderCustomerSlice.reducer;
